import React, { Fragment, useState } from 'react';
import Meta from 'antd/es/card/Meta';
import { Button, Card, Drawer, Empty, Popconfirm, Skeleton, Space, Typography } from 'antd';
import { PushpinTwoTone, CloseCircleTwoTone, DeleteTwoTone, EditTwoTone } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import DailyRunRateActions from '@Actions/inventory/dailyRunRateActions';
import H3Text from '@Uilib/h3Text';
import './style.scss';
import { faPen, faThumbtack, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { Text } = Typography;

const DailyRunRateCards = ({ isLoading, drrItem, drrId, cardTitle, isPinned, outwardTenantStocksUnits, deleteDailyRunRateLoading, deleteDailyRunRate, pinDailyRunRate, callback, setSelectedDRR, setShowUpdateDailyRunRateModal, pinDailyRunRateLoading, setStockTypeFilter }) => {

  const inStock = !outwardTenantStocksUnits || !outwardTenantStocksUnits?.length
    ? 0
    : outwardTenantStocksUnits?.reduce((acc, curr) => {
      return curr?.status === 'In Stock' ? acc + 1 : acc;
    }, 0);
  const runningLow = !outwardTenantStocksUnits || !outwardTenantStocksUnits?.length
    ? 0
    : outwardTenantStocksUnits?.reduce((acc, curr) => {
      return curr?.status === 'Running Low' ? acc + 1 : acc;
    }, 0);
  const outOfStock =
    !outwardTenantStocksUnits || !outwardTenantStocksUnits?.length
      ? 0
      : outwardTenantStocksUnits?.reduce((acc, curr) => {
        return curr?.status === 'Out of Stock' ? acc + 1 : acc;
      }, 0);

  return (
    <Fragment>
      <Card className="drr_card">
        <div className="drr_card_header">
          <div className="drr_card_header-left" onClick={() => setStockTypeFilter('In Stock')}>
            <div className="drr_card_header-title">
              {cardTitle}
              <H3Text text={drrItem?.tenant_info?.tenant_name} className="table-subscript" />
            </div>
            {!outwardTenantStocksUnits || !outwardTenantStocksUnits?.length ? (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} imageStyle={{ height: '25px' }} />
            ) : (
              <div className="drr_card_body_stock_count_wrapper">
                <div className="drr_card_body_stock_count_container">
                  <div>
                    <Text className="drr_card_body_stock_count">In Stock</Text>
                    <Text
                      className="drr_card_body_stock_count"
                      type="success"
                    >
                      {inStock}
                    </Text>
                  </div>
                  <div>
                    <Text className="drr_card_body_stock_count">Running Low</Text>
                    <Text
                      className="drr_card_body_stock_count"
                      type="warning"
                    >
                      {runningLow}
                    </Text>
                  </div>
                  <div>
                    <Text className="drr_card_body_stock_count">Out of Stock</Text>
                    <Text
                      className="drr_card_body_stock_count"
                      type="danger"
                    >
                      {outOfStock}
                    </Text>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="drr_card_header-right flex-display">
            <div>
              <Button
                className="action_icon"
                type="ghost"
                ghost
                // icon={<EditTwoTone className="drr_card_header_icon" />}
                icon={<FontAwesomeIcon icon={faPen} className="drr_card_header_icon" style={{ color: "#2d7df7" }}/>}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedDRR(drrItem);
                  setShowUpdateDailyRunRateModal(true);
                }}
              />
            </div>
            <div>
              <Popconfirm
                className="action_icon"
                title="Are you sure you want to remove this item?"
                onConfirm={(e) => {
                  e.stopPropagation();
                  const payload = {
                    drr_id: drrId,
                  };
                  deleteDailyRunRate(payload, () => {
                    callback();
                  });
                }}
                onCancel={(e) => {
                  e.stopPropagation();
                }}
              >
                <Button
                  className="action_icon"
                  type="ghost"
                  ghost
                  // icon={<DeleteTwoTone twoToneColor="#ff0000" className="drr_card_header_icon" />}
                  icon={<FontAwesomeIcon icon={faTrash} className="drr_card_header_icon" style={{ color: "#ff0000" }}/>}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                />
              </Popconfirm>
            </div>
            <div>
              <Button
                type="ghost"
                ghost
                onClick={(e) => {
                  e.stopPropagation();
                  const payload = {
                    drr_id: drrId,
                    is_pinned: !isPinned,
                  };
                  pinDailyRunRate(payload, () => {
                    callback();
                  });
                }}
                icon={isPinned ? (
                  // <PushpinTwoTone
                  //   twoToneColor="#52c41a"
                  //   className="drr_card_header_icon"
                  // />
                  <FontAwesomeIcon icon={faThumbtack} style={{ color: "#52c41a" }} className="drr_card_header_icon" />
                ) : (
                  // <PushpinTwoTone
                  //   twoToneColor="#ff0000"
                  //   className="drr_card_header_icon"
                  // />
                  <FontAwesomeIcon icon={faThumbtack} style={{ color: "#ff0000" }} className="drr_card_header_icon" />
                )}
              />
            </div>
          </div>
        </div>
      </Card>
    </Fragment>
  )
};

const mapStateToProps = ({
  DailyRunRateReducers,
}) => ({
  deleteDailyRunRateLoading: DailyRunRateReducers.deleteDailyRunRateLoading,
  pinDailyRunRateLoading: DailyRunRateReducers.pinDailyRunRateLoading,
});

const mapDispatchToProps = (dispatch) => ({
  deleteDailyRunRate: (payload, callback) => dispatch(DailyRunRateActions.deleteDailyRunRate(payload, callback)),
  pinDailyRunRate: (payload, callback) => dispatch(DailyRunRateActions.pinDailyRunRate(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DailyRunRateCards));
